import type { FC } from "react";

import { InputEditButton, TextInput } from "@ui/components/Inputs";
import { useTranslations } from "@ui/providers/useTranslations";

import { toast } from "@jti/core-components/components/Toaster";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./CopyCodeButton.module.scss";

type CopyCodeButtonProps = {
  value: string;
  prefix?: string;
  onCopy?: () => void;
};

export const CopyCodeButton: FC<CopyCodeButtonProps> = ({ value, prefix, onCopy }) => {
  const { __ } = useTranslations();

  const handleCopy = async () => {
    if ("clipboard" in navigator) {
      try {
        await navigator.clipboard.writeText(value);
        toast.success(__("copy.code.button"));
        dispatchTrackingEvent(TrackingEvents.TrackingReferralCodeCopyButtonClick);
        onCopy?.();
      } catch (error) {
        console.error("Failed to copy text: ", error);
      }
    } else {
      document.execCommand("copy", true, value);
      toast.success(__("copy.code.button"));
    }
  };

  const displayedValue = prefix ? `${prefix} ${value}` : value;

  return (
    <TextInput
      id="copy-code-input"
      value={displayedValue}
      readOnly={true}
      elemAfter={<InputEditButton label={__("copy.code.button.label", undefined, "Copy")} onClick={handleCopy} />}
      containerClassName={styles.container}
      aria-label={displayedValue}
    />
  );
};
